<template>
  <CardLikeContainer :class="$style.card" @click="emit('click')">
    <section :class="$style.card__description">
      {{ startsAt }} &#12316; {{ endsAt }}
    </section>
  </CardLikeContainer>
</template>

<script setup lang="ts">
import CardLikeContainer from '@/components/atoms/CardLikeContainer.vue'
import { computed } from 'vue'

import { format } from 'date-fns'
import type { TimeSlot } from './useTimeSlot'

const props = defineProps<{
  timeSlot: TimeSlot
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()

const startsAt = computed(() =>
  format(new Date(props.timeSlot.startsAt), 'H:mm')
)
const endsAt = computed(() => format(new Date(props.timeSlot.endsAt), 'H:mm'))
</script>

<style module lang="scss">
.card {
  cursor: pointer;

  &__close {
    font-size: 12px;
  }

  &__heading {
    font-size: 12px;
    font-weight: 700;
  }

  &__description {
    margin-top: 0;
    font-size: 12px;
    font-weight: 700;
  }
}
</style>
